import useSeti from '@/hooks/useSeti'

export default function usePkgDefaultHpSearchPassengers(adultCount?: number | null): number {
  // Only enter the experiment when the variant actually decides the default,
  // otherwise the pre-populated count dilutes the results.
  const setiVariant = useSeti({
    experimentCode: 'PKG_DEFAULT_HP_SEARCH_PASSENGERS',
    shouldFireImpression: !adultCount,
  })
  if (adultCount) return adultCount
  return setiVariant === 'VARIANT' ? 1 : 2
}
